import { searchCffCustomers, searchCffItems, type CffCustomerLookup, type CffItemLookup } from './customerFeedbackLookup';
import { fetchDemCustomers } from './demCustomers';
import type { CffAsyncOption } from '../components/forms/CffAsyncTypeahead';

export type PufCustomerLookup = CffCustomerLookup & {
  customer_price_group: string;
};

export type PufItemLookup = CffItemLookup;

async function demPriceGroupForCode(code: string): Promise<string> {
  const trimmed = code.trim();
  if (!trimmed) return '';
  try {
    const { rows } = await fetchDemCustomers({
      search: trimmed,
      pageSize: 25,
      blockedFilter: 'all',
    });
    const exact = rows.find((row) => row.code.trim().toUpperCase() === trimmed.toUpperCase());
    return String(exact?.price_group ?? '').trim();
  } catch {
    return '';
  }
}

export async function searchPufCustomers(query: string): Promise<PufCustomerLookup[]> {
  const customers = await searchCffCustomers(query);
  const enriched: PufCustomerLookup[] = [];
  for (const row of customers) {
    let priceGroup = String(row.customer_price_group ?? '').trim();
    if (!priceGroup && row.no.trim()) {
      priceGroup = await demPriceGroupForCode(row.no);
    }
    enriched.push({
      ...row,
      customer_price_group: priceGroup,
    });
  }
  return enriched;
}

export async function searchPufItems(query: string): Promise<PufItemLookup[]> {
  return searchCffItems(query);
}

export function pufCustomerOptions(rows: PufCustomerLookup[]): CffAsyncOption[] {
  return rows.map((row) => ({
    value: row.no,
    label: row.name ? `${row.no} — ${row.name}` : row.no,
    meta: row,
  }));
}

export function pufItemOptions(rows: PufItemLookup[]): CffAsyncOption[] {
  return rows.map((row) => ({
    value: row.no,
    label: row.description ? `${row.no} — ${row.description}` : row.no,
    meta: row,
  }));
}
